import {useMutation} from "@tanstack/react-query";
import {ChallengesApi} from "@devour/client";
import getConfig from "@/utils/getConfig";
import {useSelector} from "react-redux";
import {IStore} from "@/redux/defaultStore";

export function useConfirmNotifyPrizeWon() {
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);
    return useMutation({
        mutationFn: async (id: string) => {
            return new ChallengesApi(getConfig(fullToken)).updateConfirmNotifyPrizeWonId({ id });
        },
    });
}
